import { createReducer, on } from "@ngrx/store";
import * as TaskFolderActions from "./task-folder.actions";
import { TaskFolder } from "./task-folder.model";

export const taskFolderFeatureKey = "taskFolders";

export interface TaskFolderState {
  folders: TaskFolder[];
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const initialState: TaskFolderState = {
  folders: [],
  loading: false,
  loaded: false,
  error: null
};

export const taskFolderReducer = createReducer(
  initialState,

  on(TaskFolderActions.loadTaskFolders, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(TaskFolderActions.loadTaskFoldersSuccess, (state, { folders }) => ({
    ...state,
    folders,
    loading: false,
    loaded: true
  })),

  on(TaskFolderActions.loadTaskFoldersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
